import { render, staticRenderFns } from "./InternalLinkForm.vue?vue&type=template&id=53f82782&"
import script from "./InternalLinkForm.vue?vue&type=script&lang=js&"
export * from "./InternalLinkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports